const achievementActionTypes = {
  fetch_all_achievements: "FETCH_ALL_ACHIEVEMENTS",
  fetch_single_achievement: "FETCH_SINGLE_ACHIEVEMENT",
};

export default achievementActionTypes;